import { useEffect, useRef } from "react";
import { useAppSelector } from "./redux";
import { cdlRepository, timeProvider } from "../AppController";
import { useDashboardStats } from "./useDashboardStats";
import {
  STATS_FRESHNESS_MINUTES,
  STATS_POLL_INTERVAL_MS,
} from "../constants/stats";

export const useStatsTimeout = () => {
  const { stats, statsHR, getStatsData, getStatsDataHR } = useDashboardStats({
    cdlRepository: cdlRepository,
    timeProvider,
  });
  const { statsTimeout, isPinAuthorized } = useAppSelector((state) => ({
    statsTimeout: state.dashboard.statsTimeout,
    isPinAuthorized: state.auth.isPinAuthorized,
  }));

  const statsRef = useRef(stats);
  statsRef.current = stats;
  const statsHRRef = useRef(statsHR);
  statsHRRef.current = statsHR;

  const hasFreshnessPassed = (unixTimestamp: number) => {
    return timeProvider
      .dateLibrary()
      .isAfter(
        timeProvider.dateLibrary
          .unix(unixTimestamp)
          .add(STATS_FRESHNESS_MINUTES, "minutes")
      );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (isPinAuthorized && statsTimeout && hasFreshnessPassed(statsTimeout)) {
        const patientIds = Object.keys({
          ...statsRef.current,
          ...statsHRRef.current,
        }).map(Number);

        getStatsData(patientIds);
        getStatsDataHR(patientIds);
      }
    }, STATS_POLL_INTERVAL_MS);

    return () => {
      clearInterval(interval);
    };
  }, [statsTimeout, isPinAuthorized]);
};
